import * as React from 'react';
import { Text, View, StyleSheet, ActivityIndicator, ViewStyle } from 'react-native';
import { Card, Modal, Layout } from './_primatives';

interface LoadingIndicatorProps {
    style?: ViewStyle;
}

export const LoadingIndicator = (props: LoadingIndicatorProps) => (
    <Layout style={[styles.container, props.style]}>
        <ActivityIndicator />
        <Text>{'  Loading...'}</Text>
    </Layout>
);




export const PageLoadingIndicator = () => (
    <LoadingIndicator
        style={styles.pageContainer}
    />
);

export const ModalLoadingIndicator = ({ modalVisible }) => (
    <Modal backdropStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }} visible={modalVisible}>
        <Card>
            <LoadingIndicator />
        </Card>
    </Modal>
);




const styles = StyleSheet.create({
    container: { flexDirection: 'row', justifyContent: 'center', alignItems: 'center' },
    pageContainer: { flex: 1 }
});
